import { LogModel } from '../models';
import ChangeLogFormatter from './ChangeLogFormatter';
import ErrorLogFormatter from './ErrorLogFormatter';
import ShareLogFormatter from './ShareLogFormatter';
import AuditLogFormatter from './AuditLogFormatter';

export interface LogActionFormatterProps {
  log: LogModel;
  onSeeMore?: (type?: string) => void;
}
export function LogActionFormatter({
  log,
  onSeeMore = () => null,
}: LogActionFormatterProps) {
  const type = log?.logType?.toLowerCase();
  if (type === 'change') {
    return (
      <ChangeLogFormatter
        action={log.action}
        data={log.data}
        onSeeMore={onSeeMore}
      />
    );
  }
  if (type === 'error') {
    return <ErrorLogFormatter action={log.action} data={log.data} />;
  }
  if (type === 'share') {
    return (
      <ShareLogFormatter
        action={log.action}
        performedBy={log.performedBy.personName}
      />
    );
  }
  if (type === 'audit') {
    return <AuditLogFormatter action={log.action} data={log} />;
  }
  return null;
}
